'use client'

import { device } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { Col } from 'antd'
import { CollapsableProps } from '~types/search'
import useWindowMobile from '../useCases/useWindowMobile'
import CollapsableAggregates from './CollapsableAggregates'

const FiltersCol = (props: CollapsableProps) => {
  const isScreenMobile = useWindowMobile()
  const isMobile = device(props.userAgent).isMobile()

  if (isMobile || isScreenMobile) {
    return null
  }

  return (
    <Col flex="0 1 235px">
      <CollapsableAggregates
        aggregates={props.aggregates}
        currencyLocale={props.currencyLocale}
        currencyFormat={props.currencyFormat}
        urlParams={props.urlParams}
        userAgent={props.userAgent}
      />
    </Col>
  )
}

export default FiltersCol
